import React from "react";

export const INPUT_CLS =
  "block w-full rounded-xl border border-slate-200 dark:border-dark-600 bg-white dark:bg-dark-900 py-2.5 px-3.5 text-xs font-semibold text-slate-800 dark:text-white focus:outline-none focus:border-primary-500 focus:ring-4 focus:ring-primary-500/10 placeholder:text-slate-400 transition-all duration-150 shadow-2xs";

export const LABEL_CLS =
  "input-label flex items-center gap-1 mb-1.5 text-xs font-bold text-slate-700 dark:text-dark-200";

export function Field({ label, required = false, children, className = "", id, error = "" }) {
  return (
    <div id={id} className={`flex flex-col ${className}`}>
      {label && (
        <label className={LABEL_CLS}>
          <span>{label}</span>
          {required && <span className="text-rose-500 ml-0.5 font-bold">*</span>}
        </label>
      )}
      {children}
      {error && (
        <span className="mt-1 text-[11px] font-semibold text-rose-500 animate-in fade-in duration-150">
          {error}
        </span>
      )}
    </div>
  );
}

export default Field;
